
define('ldsh!modules/editor/templates/elements_popup_info', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="popup-warning-advice">\n  <h4 data-i18n="editor.popup.titleMiniHelp"></h4>\n<!--  <img src="/app/img/popups.png" alt="Popups">-->\n\n  <p><span data-i18n="editor.popup.onEdit"></span> <strong>#popup' +
((__t = ( stepNumber )) == null ? '' : __t) +
'</strong></p>\n  <p><span class="js-help" data-i18n="editor.popup.linkHelp"></span></p>\n\n  <div role="tooltip" class="tooltip bottom js-tooltip">\n    <div class="tooltip-arrow"></div>\n    <div class="tooltip-inner">\n      <span class="js-help">\n        <i class="ri-close-line"></i>\n      </span>\n      <h5 data-i18n="editor.popup.exampleCodes"></h5>\n      <dl>\n        <dt data-i18n="editor.popup.exampleCodeLink"></dt>\n        <dd>\n          <span data-i18n="editor.popup.codeLinkGuidelines"></span>\n          <button class="js-copyToClipboard" data-copy-text="' +
((__t = (copyText)) == null ? '' : __t) +
'" data-copied-text="' +
((__t = (copiedText)) == null ? '' : __t) +
'">' +
((__t = (copyText)) == null ? '' : __t) +
'</button>\n          <code>&lt;a href="#popup' +
((__t = ( stepNumber )) == null ? '' : __t) +
'"&gt;' +
((__t = (openPopupLabel)) == null ? '' : __t) +
'&lt;/a&gt;</code>\n        </dd>\n\n        <dt data-i18n="editor.popup.exampleCodeButton"></dt>\n        <dd>\n          <span data-i18n="editor.popup.codeButtonGuidelines"></span>\n          <button class="js-copyToClipboard" data-copy-text="' +
((__t = (copyText)) == null ? '' : __t) +
'" data-copied-text="' +
((__t = (copiedText)) == null ? '' : __t) +
'">' +
((__t = (copyText)) == null ? '' : __t) +
'</button>\n          <code>#popup' +
((__t = ( stepNumber )) == null ? '' : __t) +
'</code>\n        </dd>\n\n        <dt data-i18n="editor.popup.exampleCodeImage"></dt>\n        <dd>\n          <span data-i18n="editor.popup.codeImageGuidelines"></span>\n          <button class="js-copyToClipboard" data-copy-text="' +
((__t = (copyText)) == null ? '' : __t) +
'" data-copied-text="' +
((__t = (copiedText)) == null ? '' : __t) +
'">' +
((__t = (copyText)) == null ? '' : __t) +
'</button>\n          <code>#popup' +
((__t = ( stepNumber )) == null ? '' : __t) +
'</code>\n        </dd>\n      </dl>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

